import * as React from "react";
import Loadable from "react-loadable";
import { RouteComponentProps } from "react-router-dom";
import { useSelector } from "react-redux";
import styled from "styled-components";

import { LOADABLE_COMPONENT_DELAY } from "@config/consts";

import { Container } from "@ui/Atoms/Grid";
import { ImpersonatorNotification } from "@ui/Molecules";

import {
  isAdminImpersonator as isAdminImpersonatorSelector,
  isUserAdmin,
} from "@soft/redux/user/user.selectors";

import { ContractDetailsPageSkeleton } from "./ValidateContractDetails/ValidateContractDetails.skeletons";

const LoadableValidateContractDetails: any = Loadable({
  loader: () => import("./ValidateContractDetails"),
  render(loaded: any, props: any): JSX.Element {
    const Component = loaded.ValidateContractDetails;
    return <Component {...props} />;
  },
  loading: ContractDetailsPageSkeleton,
  delay: LOADABLE_COMPONENT_DELAY,
});

const ValidateContract = (props: RouteComponentProps): React.ReactElement => {
  const isAdminImpersonator = useSelector(isAdminImpersonatorSelector);
  const isAdmin = useSelector(isUserAdmin);

  return !isAdminImpersonator && isAdmin ? (
    <ImpersonatorNotification />
  ) : (
    <StyledContainer>
      <LoadableValidateContractDetails {...props} />
    </StyledContainer>
  );
};

export { ValidateContract };

const StyledContainer = styled(Container)`
  ${props => props.theme.breakpoints.desktop} {
    padding-top: ${props => props.theme.margins.base_x4};
    padding-bottom: ${props => props.theme.margins.base_x4};
  }
`;
